import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { SmartRenderer } from '../../../fc-core/src/component-interface';
import { pluckNumber } from '../../../fc-core/src/lib';
import AnnotationGroup from './shapes/annotation-group';
import CircleAnnotation from './shapes/annotation-circle';
import PathAnnotation from './shapes/annotation-path';
import RectAnnotation from './shapes/annotation-rect';
import PolygonAnnotation from './shapes/annotation-polygon';
import ImageAnnotation from './shapes/annotation-image';
import TextAnnotation from './shapes/annotation-text';
var shapeMap = {
  circle: CircleAnnotation,
  arc: CircleAnnotation,
  line: PathAnnotation,
  path: PathAnnotation,
  rectangle: RectAnnotation,
  polygon: PolygonAnnotation,
  image: ImageAnnotation,
  text: TextAnnotation
};

var AnnotationController =
/*#__PURE__*/
function (_SmartRenderer) {
  _inherits(AnnotationController, _SmartRenderer);

  function AnnotationController() {
    _classCallCheck(this, AnnotationController);

    return _possibleConstructorReturn(this, _getPrototypeOf(AnnotationController).apply(this, arguments));
  }

  _createClass(AnnotationController, [{
    key: "createItem",
    value: function createItem(a, b) {
      var c,
          d,
          e = this;
      if ('group' === a.annotationType) a.groupXShift = pluckNumber(a.groupXShift, this.config.groupXShift), a.groupYShift = pluckNumber(a.groupYShift, this.config.groupYShift), c = e.attachChild(AnnotationGroup, 'group', a.id), e.config.lastCreatedGroup = c;else {
        if (d = a.type && a.type.toLowerCase(), c = b.attachChild(shapeMap[d], 'item', a.id), !c) return;
        e.config.lastCreatedItem = c;
      }
      return c._setToStore('component', a.component), c.configure(a), c;
    }
  }, {
    key: "retrieveItem",
    value: function retrieveItem(a, b) {
      var c, d, e;

      for (e in this.groups) {
        if (c = this.groups[e].retrieveItem(a, b), c) {
          d = c;
          break;
        }
      }

      return d;
    }
  }, {
    key: "retrieveGroup",
    value: function retrieveGroup(a, b) {
      var c,
          d,
          e = this;
      if (b) e.detachChild(a);else for (c = 0, d = e.groups.length; c < d; c++) {
        if (e.groups[c].getId() === a) return e.groups[c];
      }
    }
  }, {
    key: "show",
    value: function show(a) {
      var b;
      a ? (b = this.retrieveItem(a) || this.retrieveGroup(a), b && b.show()) : this.groups.forEach(function (a) {
        a.show(), a.items.forEach(function (a) {
          a.show();
        });
      });
    }
  }, {
    key: "hide",
    value: function hide(a) {
      var b;
      a ? (b = this.retrieveItem(a) || this.retrieveGroup(a), b && b.hide()) : this.groups.forEach(function (a) {
        a.hide(), a.items.forEach(function (a) {
          a.hide();
        });
      });
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var a,
          b,
          c,
          d,
          e,
          f,
          g = this,
          h = g.config;

      if (h.groups) {
        for (c = h.groups.length, a = c - 1; 0 <= a; a--) {
          for (e = h.groups[a], d = e.items && e.items.length, b = d - 1; 0 <= b; b--) {
            f = e.items[b], f && f.dispose();
          }

          e.items = [], e.dispose();
        }

        h.groups = [];
      }
    }
  }, {
    key: "disposeConfiguration",
    value: function disposeConfiguration() {
      var a = this,
          b = a.config;
      b.parsedConfigs = [], b.groups = [];
    }
  }]);

  return AnnotationController;
}(SmartRenderer);

export default AnnotationController;